export default {
  width: 22,
  height: 26,
  svg: `
<path d="M15.734 6.40001L9.66732.333344V4.42668C4.41398 5.08001.333984 9.56001.333984 15c0 5.44 4.066666 9.92 9.333336 10.5733V22.88c-3.78667-.64-6.66667-3.92-6.66667-7.88s2.88-7.23999 6.66667-7.87999v5.21329L15.734 6.40001zm5.84 7.26669c-.2267-1.8534-.96-3.64-2.16-5.18669l-1.8934 1.89329c.72 1 1.1734 2.1334 1.36 3.2934h2.6934zm-9.24 9.2V25.56c1.8533-.2267 3.6533-.9467 5.2-2.1467l-1.92-1.92c-1 .72-2.12 1.1867-3.28 1.3734zm5.1866-3.2267l1.8934 1.88c1.2-1.5467 1.9333-3.3333 2.16-5.1867h-2.6934c-.1866 1.16-.64 2.2934-1.36 3.3067z"/>  
  `
}
